import * as yup from 'yup';

export const paintedElementIdValidation = yup.object({
  id: yup
    .string()
    .length(24, 'ID musi mieć długość 24 znaków')
    .matches(/^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i, 'Nieprawidłowe ID')
    .required('ID jest wymagane'),
});
